import {pxToRem} from '../../utills/pxToRem'

export const normalTextStyle = {
    fontSize: {base: pxToRem(12), lg: pxToRem(13)},
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}

export const tileStyle = {
    display: 'flex',
    flexDir: 'column',
    layerStyle: 'cardBordered',
    padding: {base: pxToRem(15), lg: `${pxToRem(23)} ${pxToRem(18)}`},
    gap: {base: pxToRem(10), lg: pxToRem(10)},
    boxShadow: `${pxToRem(2)} ${pxToRem(4)} ${pxToRem(16.6)} ${pxToRem(2)} rgba(0, 0, 0, 0.25)`,
    mt: '0 !important'
}

export const orderSummaryStyle = {
    background: 'gray.75',
    padding: {base: `${pxToRem(15.5)} ${pxToRem(10)} !important`, lg: `${pxToRem(25)} !important`},
    h2: {
        ...normalTextStyle,
        textTransform: 'capitalize',
        fontWeight: 'medium',
        margin: '0 !important'
    },
    p: {
        fontSize: {base: pxToRem(12), lg: pxToRem(13)},
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: pxToRem(1),
        margin: '0 !important'
    },
    span: {
        ...normalTextStyle,
        margin: '0 !important'
    },
    div: {
        margin: '0 !important'
    },
    '>div': {
        gap: pxToRem(25),
        '>div': {
            gap: {base: pxToRem(10), lg: pxToRem(15)},
            '>div': {
                gap: {base: pxToRem(10), lg: pxToRem(15)}
            }
        }
    },
    hr: {
        margin: '0 !important'
    }
}

export const orderDetailsGridStyle = {
    '.detail-item': {
        gap: {base: pxToRem(5), lg: 3}
    },
    div: {
        margin: '0 !important'
    },
    h2: {
        ...normalTextStyle,
        margin: '0 !important',
        fontWeight: 'medium',
        padding: '0 !important'
    },
    p: {
        ...normalTextStyle,
        margin: '0 !important'
    }
}

export const orderItemContainerStyle = {
    gap: {base: pxToRem(15), lg: pxToRem(25)},
    mt: '0 !important',
    p: {
        margin: '0 !important'
    }
}
